'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n'], ['\n  display: flex;\n  flex-direction: row;\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 16px;\n  font-size: 16px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: ', ';\n'], ['\n  margin-left: 16px;\n  font-size: 16px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: ', ';\n']),
  _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0px;\n  width: 0px;\n'], ['\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0px;\n  width: 0px;\n']),
  _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  cursor: ', ';\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 20px;\n  height: 20px;\n'], ['\n  position: relative;\n  cursor: ', ';\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 20px;\n  height: 20px;\n']),
  _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 16px;\n  width: 16px;\n  box-sizing: content-box;\n  border-radius: 50%;\n  border-color: ', ';\n  border-width: 2px;\n  border-style: solid;\n  opacity: ', ';\n  background-color: ', ';\n\n  &:after {\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #6E0AD6;\n    content: "";\n    display: ', ';\n  }\n'], ['\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 16px;\n  width: 16px;\n  box-sizing: content-box;\n  border-radius: 50%;\n  border-color: ', ';\n  border-width: 2px;\n  border-style: solid;\n  opacity: ', ';\n  background-color: ', ';\n\n  &:after {\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #6E0AD6;\n    content: "";\n    display: ', ';\n  }\n']); /* eslint-disable jsx-a11y/label-has-for */
// eslint-disable-line

var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _uuid = require('uuid');
var _uuid2 = _interopRequireDefault(_uuid);
var _View = require('../View');
var _View2 = _interopRequireDefault(_View);
var _Text = require('../../fundamentals/Text');
var _Text2 = _interopRequireDefault(_Text);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Content = (0, _styledComponents2.default)(_View2.default)(_templateObject);
var LabelText = (0, _styledComponents2.default)(_Text2.default)(_templateObject2, function (props) {
  return props.disabled ? '#999999' : 'inherit';
});
var basicRadio = function basicRadio(props) {
  return _react2.default.createElement('input', {
    id: props.id,
    className: props.className,
    value: props.value,
    name: props.name,
    checked: props.checked,
    onChange: props.onChange,
    disabled: props.disabled,
    type: 'radio'
  });
};
var Input = (0, _styledComponents2.default)(basicRadio)(_templateObject3);
var InputWrapper = _styledComponents2.default.label(_templateObject4, function (props) {
  return props.disabled ? 'initial' : 'pointer';
});
var Checkmark = _styledComponents2.default.span(_templateObject5, function (props) {
  return props.checked ? '#6E0AD6' : '#999999';
}, function (props) {
  return props.disabled ? 0.3 : 1;
}, function (props) {
  return props.disabled && !props.checked ? '#d2d2d2' : '#ffffff';
}, function (props) {
  return props.checked ? 'block' : 'none';
});
var RadioInput = function RadioInput(props) {
  var elementId = (0, _uuid2.default)();
  return _react2.default.createElement(Content, null, _react2.default.createElement(InputWrapper, {
    disabled: props.disabled
  }, _react2.default.createElement(Input, {
    id: elementId,
    value: props.value,
    name: props.name,
    checked: props.checked,
    onChange: props.onChange,
    disabled: props.disabled
  }), _react2.default.createElement(Checkmark, {
    checked: props.checked,
    disabled: props.disabled
  })), _react2.default.createElement('label', {
    htmlFor: elementId
  }, _react2.default.createElement(LabelText, {
    disabled: props.disabled
  }, props.label)));
};
basicRadio.propTypes = {
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  value: _propTypes2.default.string,
  name: _propTypes2.default.string,
  checked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  disabled: _propTypes2.default.bool
};
RadioInput.propTypes = {
  disabled: _propTypes2.default.bool,
  checked: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};
exports.default = RadioInput;